const React = require('react');
const { useCore } = require('stremio/core');
const useProfile = require('stremio/common/useProfile');

// Remove only the hosted endpoint installed by the retired media experiment.
module.exports = function RetiredMediaCleanup() {
    const core = useCore();
    const profile = useProfile();
    React.useEffect(() => {
        sessionStorage.removeItem('watchparty-media-key');
        fetch('/api/media').catch(() => {});
        const hash = location.hash.split('?');
        const params = new URLSearchParams(hash[1] || '');
        if (params.has('access')) {
            params.delete('access');
            history.replaceState(null, '', `${location.pathname}${location.search}${hash[0]}${params.toString() ? `?${params}` : ''}`);
        }
    }, []);
    React.useEffect(() => {
        const retired = ['https://nifemi-watchparty.duckdns.org/', `${location.origin}/`];
        if (!retired.includes(profile.settings.streamingServerUrl)) return;
        core.transport.dispatch({ action: 'Ctx', args: { action: 'UpdateSettings', args: {
            ...profile.settings, streamingServerUrl: 'http://127.0.0.1:11470/'
        } } });
        core.transport.dispatch({ action: 'Ctx', args: { action: 'DeleteServerUrl', args: profile.settings.streamingServerUrl } });
        core.transport.dispatch({ action: 'StreamingServer', args: { action: 'Reload' } });
    }, [profile.settings.streamingServerUrl]);
    return null;
};
